// extracted by mini-css-extract-plugin
export var emailBlockLink = "_iy-0";